var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-6"},[_c('h3',{staticClass:"text-center mt-3"},[_vm._v("Vuoi ricevere una consulenza dai nostri nutrizionisti?")]),_c('p',{staticClass:"text-center mt-3"},[_vm._v("Compila il form a questo "),_c('a',{attrs:{"href":"/contatta-nutrizionista"}},[_vm._v("link")]),_vm._v(" per ricevere un piano dedicato alle tue esigenze")])])
}]

export { render, staticRenderFns }